import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Bookmark from '@alltrails/denali/icons/Bookmark';
import BookmarkFilled from '@alltrails/denali/icons/BookmarkFilled';
import Heart from '@alltrails/denali/icons/Heart';
import HeartFilled from '@alltrails/denali/icons/HeartFilled';
import { useExperiments } from '@alltrails/experiments';
import styles from './TopResults.module.scss';

type Props = {
  isFavorite: boolean;
  onClick: () => void;
};

const BookmarkButtonWrapper = ({ isFavorite, onClick }: Props) => {
  const intl = useIntl();
  const experiments = useExperiments();
  const useHeartIcon = experiments['web-saved-heart-icon']?.value === 'on';

  const IconComponent = useHeartIcon
    ? (isFavorite ? HeartFilled : Heart)
    : (isFavorite ? BookmarkFilled : Bookmark);

  const title = useHeartIcon
    ? (isFavorite ? intl.formatMessage({ defaultMessage: 'Saved' }) : intl.formatMessage({ defaultMessage: 'Save' }))
    : intl.formatMessage({ defaultMessage: 'Add to list' });

  return (
    <IconButton
      className={styles.trailCardSnippetBookmark}
      icon={{ Component: IconComponent }}
      onClick={onClick}
      title={title}
      testId="location-page-bookmark"
      size="sm"
    />
  );
};

export default BookmarkButtonWrapper;
